import request from '../request'

//  Get marking by classId and ulIds and studentIds
export const getStudentsMarkingAllByClassIdAndUlId = (curriculumId, classId, drId, studentIds) =>
  request
    .post(`/assessment/${curriculumId}/maestro/marking/class/${classId}/developmental-rubric/${drId}`, {
      studentIds
    })
    .then((res) => res)

// Get marking by classId and ulIds and studentId
export const getStudentMarkingByClassIdAndUlId = (curriculumId, classId, drId, studentId) =>
  request
    .get(
      `/assessment/${curriculumId}/maestro/marking/class/${classId}/developmental-rubric/${drId}/student/${studentId}`
    )
    .then((res) => res)

// MF-187 — Rubric PDFs (responseType blob → returns the Blob via the response interceptor).
const rubricPdfBase = (curriculumId, classId, drId) =>
  `/assessment/${curriculumId}/maestro/marking/class/${classId}/developmental-rubric/${drId}/pdf`

// Rubric Reference PDF (no marking) for the unit.
export const downloadRubricReferencePdf = (curriculumId, classId, drId) =>
  request.get(`${rubricPdfBase(curriculumId, classId, drId)}/reference`, { responseType: 'blob' })

// Progress Report PDF (with marking) for one student.
export const downloadStudentProgressPdf = (curriculumId, classId, drId, studentId) =>
  request.get(`${rubricPdfBase(curriculumId, classId, drId)}/progress/student/${studentId}`, {
    responseType: 'blob'
  })

// Progress Report ZIP (one PDF per student) for the whole class.
export const downloadClassProgressZip = (curriculumId, classId, drId) =>
  request.get(`${rubricPdfBase(curriculumId, classId, drId)}/progress/class`, { responseType: 'blob' })

// Update student marking by studentId and classId
export const updateStudentMarkingByClassIdAndUlId = (curriculumId, classId, drId, studentId, type, data) =>
  request
    .put(
      `/assessment/${curriculumId}/maestro/marking/class/${classId}/developmental-rubric/${drId}/student/${studentId}/type/${type}`,
      data
    )
    .then((res) => res)

// Update student marking by studentId and classId
export const updateStudentsBulkMarkingByClassIdAndUlId = (curriculumId, classId, drId, studentIds, data) =>
  request
    .put(
      `/assessment/${curriculumId}/maestro/marking/class/${classId}/developmental-rubric/${drId}/student/bulk`,
      { studentIds, ...data }
    )
    .then((res) => res)

export const getMarkingStudentDataForLearningMatrix = (curriculumId, studentId, data) =>
  request
    .post(`/assessment/${curriculumId}/maestro/marking/learning-matrix/student/${studentId}`, data)
    .then((res) => res)

export const getMarkingStudentDataForLearningGrowth = (curriculumId, studentId, data) =>
  request
    .post(`/assessment/${curriculumId}/maestro/learning-growth/student/${studentId}/today`, data)
    .then((res) => res)

export const getMarkingStudentDataForLearningGrowthRange = (curriculumId, studentId, data) =>
  request
    .post(`/assessment/${curriculumId}/maestro/learning-growth/student/${studentId}/range`, data)
    .then((res) => res)

export const getMarkingStudentDataForLearningGrowthUnitOflearning = (curriculumId, studentId, data) =>
  request
    .post(`/assessment/${curriculumId}/maestro/learning-growth/student/${studentId}/units-of-learning`, data)
    .then((res) => res)
export const getInfoForDashboard = (curriculumId, classId, drId, lcId, data) =>
  request
    .post(
      `/assessment/${curriculumId}/maestro/analytics/class/${classId}/developmental-rubric/${drId}/learning-continuum/${lcId}/dashboard`,
      data
    )
    .then((res) => res)

export const getCurriculumLevelsAnalytics = (curriculumId, studentId, data) =>
  request
    .post(`/assessment/${curriculumId}/maestro/analytics/student/${studentId}/curriculum-levels`, data)
    .then((res) => res)

export const getStudentDistribution = (curriculumId, data) =>
  request.post(`/assessment/${curriculumId}/maestro/analytics/student-distribution`, data).then((res) => res)

// Group marking
export const updateStudentsGroupMarkingByClassIdAndUlIdAndLcId = (
  curriculumId,
  classId,
  drId,
  lcId,
  students
) =>
  request
    .put(
      `/assessment/${curriculumId}/maestro/marking/class/${classId}/developmental-rubric/${drId}/learning-continuum/${lcId}/group`,
      {
        students
      }
    )
    .then((res) => res)
